import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {PopupComponent} from '../popup/popup.component';
import {MatDialog} from '@angular/material/dialog';
import {environment as env} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {ConfigService} from '../config/config.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {LanguageService} from '../service/language.service';

@Component({
    selector: 'app-account-settings',
    templateUrl: './account-settings.component.html',
    styleUrls: ['./account-settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AccountSettingsComponent implements OnInit {
  @Input() loggedInUser: any;

  constructor(public dialog: MatDialog, private http: HttpClient,
              private api: ConfigService, private snackBar: MatSnackBar,  private router: Router,
              // tslint:disable-next-line:variable-name
              private translate: TranslateService, private _language: LanguageService) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }


  isLoaderVisible = false;
  errorMessage = '';
  artObjectsNr = 0;
  offersNr = 0;
  hidePass = true;
  hideConfPass = true;

  accountSettingForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required]),
    lastName: new UntypedFormControl('', [Validators.required]),
    phone: new UntypedFormControl('', [Validators.required]),
    password: new UntypedFormControl(''),
    confirmPassword: new UntypedFormControl(''),
  });

  // tslint:disable-next-line:typedef
  get firstNameFormControl() {
    return this.accountSettingForm.get('firstName') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get lastNameFormControl() {
    return this.accountSettingForm.get('lastName') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get phoneFormControl() {
    return this.accountSettingForm.get('phone') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get passwordFormControl() {
    return this.accountSettingForm.get('password') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get confirmPasswordFormControl() {
    return this.accountSettingForm.get('confirmPassword') as UntypedFormControl;
  }

  changeRole(): void {
    const name = 'LC';
    const mail = 'lupulcreativ@gmail.com';
    const message = 'Userul cu id-ul: ' + this.loggedInUser.id + 'si numele' + this.loggedInUser.full_name + ' doreste schimbarea rolului';
    this.isLoaderVisible = true;
    this.api.SendEmail(name, mail, message).subscribe(
      data => {
        // tslint:disable-next-line:no-shadowed-variable
        this.translate.get('requestSentSuccessfully').subscribe(message => {
          this.snackBar.open(message , '',
            {duration: 3000, panelClass: 'success-snack-bar',  horizontalPosition: 'end', verticalPosition: 'top'});
          this.isLoaderVisible = false;
        });
      },
      error => {
        // tslint:disable-next-line:no-shadowed-variable
        this.translate.get('errorOccurred').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar',  horizontalPosition: 'end', verticalPosition: 'top'});
          this.isLoaderVisible = false;
        });
      });
  }
  logout(): void {
    this.translate.get('sureYouWantToLogOut').subscribe(message => {
      const dialogRef = this.dialog.open(PopupComponent, {
        data: {popupText: message, popupButtonsNotVsible: 'nu'},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === true){
          localStorage.removeItem('token');
          this.router.navigate(['/']);
        }
      });
    });
  }
  checkPasswords(): boolean {
    return this.passwordFormControl.value === this.confirmPasswordFormControl.value;
  }
  actualSaveData(): void {
    this.isLoaderVisible = true;
    const firstName = this.firstNameFormControl.value;
    const lastName = this.lastNameFormControl.value;
    const phone = this.phoneFormControl.value;
    const password = this.passwordFormControl.value;

    this.api.postUserEdit(this.loggedInUser.id, firstName, lastName,
      phone, password).subscribe(data => {
      this.translate.get('modificationsSuccessfullyMade').subscribe(message => {
        this.snackBar.open(message, '',
          {duration: 3000, panelClass: 'success-snack-bar',  horizontalPosition: 'end', verticalPosition: 'top'});
        this.isLoaderVisible = false;
        this.errorMessage = '';
        location.reload();
      });
    }, err => {
      console.log('err', err);
      this.translate.get('errorOccurred').subscribe(message => {
        this.snackBar.open(message, '',
          {duration: 3000, panelClass: 'error-snack-bar',  horizontalPosition: 'end', verticalPosition: 'top'});
        this.errorMessage = '';
        this.isLoaderVisible = false;
      });
    });
  }

  saveUserData(): void {
    // daca parolele nu s goale
    const pass = this.passwordFormControl.value;
    const confPass = this.confirmPasswordFormControl.value;

    if (pass !== '' && confPass !== '') {
      if (this.checkPasswords()) {
        if (pass.length < 10) {
          this.translate.get('passwordMin10').subscribe(message => {
            this.errorMessage = message;
          });
        } else {
          this.actualSaveData();
        }
      } else {
        this.translate.get('passwordsMustBeIdentical').subscribe(message => {
          this.errorMessage = message;
        });
      }
    } else {
      this.actualSaveData();
    }
  }
  getNrOfArtObjects(): void{
    this.isLoaderVisible = true;
    this.api.getLoggedInArtistArtObjects().subscribe(data => {
        // @ts-ignore
        const addedArt = data.length;
        this.artObjectsNr = addedArt;
        this.isLoaderVisible = false;
      },
      error => {
        console.log('error', error);
        this.isLoaderVisible = false;
        this.translate.get('errorOccurred').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar',
              horizontalPosition: 'end', verticalPosition: 'top'});
        });
      });
  }
  getNrOfOffers(): void {
    this.api.getMyOffers().subscribe(data => {
        // @ts-ignore
        const offers = data.length;
        this.offersNr = offers;
        this.isLoaderVisible = false;
      },
      error => {
        console.log('getLoggedInUserArtObjects error', error);
        this.isLoaderVisible = false;
        this.translate.get('errorOccurred').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar',
              horizontalPosition: 'end', verticalPosition: 'top'});
        });
      });
  }

  getLoggedInUserData(): void {
    this.firstNameFormControl.setValue(this.loggedInUser.first_name);
    this.lastNameFormControl.setValue(this.loggedInUser.last_name);
    this.phoneFormControl.setValue(this.loggedInUser.phone_number);
    this.passwordFormControl.setValue('');
    this.confirmPasswordFormControl.setValue('');
  }

  ngOnInit(): void {
    this.getLoggedInUserData();
    this.getNrOfArtObjects();
    this.getNrOfOffers();
  }
}
